
export const polling = {
    // Error messages
    queryStatusFailed: '查询状态失败，请稍后重试',
    taskNotFound: '任务未找到，可能已被删除',
    authenticationFailed: '身份验证失败，请重新登录',
    serverInternalError: '服务器内部错误，请稍后重试',
    requestTooFrequent: '请求过于频繁，请稍后重试',
    networkConnectionFailed: '网络连接失败，请检查网络连接',
    unknownError: '未知错误',
    generationFailed: '生成失败',
    
    // Status messages
    generationTimeout: '生成超时，请重试',
    
    // Error types
    contentPolicy: '内容不符合平台政策，请修改后重试',
    recitationConcern: '内容可能涉及版权问题，请修改提示词后重试',
    rateLimit: '请求过于频繁，请稍后重试',
    credits: '积分不足，请充值后重试',
    timeout: '生成超时，请重试',
    noImageGenerated: '无法为此提示词生成图片，请尝试修改提示词',
    
    // Toast messages
    generationFailedToast: '生成失败'
  };
